{
  "title": "Terms and Conditions",
  "warning": "You should accept the terms and conditions. Check the box to proceed",
  "thirdparties": "I agree to the terms and conditions and the privacy policy of BRIDGE, a third-party service provider used by Izzi Wallet.",
  "validating": "We are validating your data, please wait..."
}
